import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  nagDashboardStepsArray,
  BASIC_ACCOUNT_STEP,
  VERIFY_ACCOUNT_STEP,
  VERIFIED_NON_POST_PAID,
  VERIFIED_POST_PAID,
  accountStatusTypesArray,
} from '../../constants/nagDashboardContants';
import { parseEnumType } from '../../util/helpers/enumMappers';
import NagDashboardVerifyAccountStep from './NagDashboardVerifyAccountStep';
import NagDashboardFundAccountStep from './NagDashboardFundAccountStep';
import NagDashboardStorageInvestmentStep from './NagDashboardStorageInvestmentStep';
import { selectNagDashboard } from '../../store/selectors/accountSelectors';
import { BUY_PAGE } from '../../constants/pages';

const NagDashboardShortBanner = ({ activeStep }) => {
  const history = useHistory();
  const nagDashboard = useSelector(selectNagDashboard);
  const isPending =
    parseEnumType(accountStatusTypesArray, nagDashboard?.AccountStatusType) ===
    'Pending';
  const isBuyPage = history.location.pathname === BUY_PAGE;
  const getShortDashboad = () => {
    switch (parseEnumType(nagDashboardStepsArray, activeStep)) {
      case BASIC_ACCOUNT_STEP:
      case VERIFY_ACCOUNT_STEP:
        return (
          <NagDashboardVerifyAccountStep
            activeStep={activeStep}
            isShortFlow={!isPending}
          />
        );
      case VERIFIED_NON_POST_PAID:
        return <NagDashboardFundAccountStep activeStep={activeStep} />;

      case VERIFIED_POST_PAID:
        if (!isBuyPage) {
          return <NagDashboardStorageInvestmentStep activeStep={activeStep} />;
        }
        return <></>;

      default:
        return <></>;
    }
  };

  return getShortDashboad();
};

export default NagDashboardShortBanner;
